import axios from 'axios'
import endpoint from '../../../utils/endpoint'

export const getGenderBalance = async text => {
    try {
        return axios.post(`${endpoint.getServiceEndpoint(process.env.NODE_ENV)}/gender-strict`, {
            text: text.replace(/[.,-/#!$%^&*;:{}=\-_`~()@+?><[\]+]/g, '')
                .replace(/"/g, ''),
        });
    }
    catch (error) {
        console.log(error);
    }
}
